var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('auth-theme-uloc'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }